"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  title: '云南',
  register1: '注册',
  register2: '注 册',
  login1: '登录',
  login2: '登 录',
  leave: '退出',
  back: '返回首页',
  orders: '我的订单',  
  ticket1: '平日普通票',
  ticket2: '平日优惠票',
  ticket3: '指定日普通票',
  ticket4: '指定日优惠票',
  ticket5: '平日票',
  ticket6: '指定日票',
  rules: '适用规则',
  immediately: '立即预订',
  notice: '入园须知',
  prompt: '购票前请您仔细阅读《入园须知》',
  accountRegister: '账户注册',
  inputPhone: '请输入手机号',
  inputPhonea: '请输入手机号和验证码',
  inputPsword: '请输入密码',
  inputCode: '请输入验证码',
  inputCode1: '请输入短信验证码',
  inputCode2: '请输入正确的验证码',
  getCode: '获取验证码',
  accountLogin: '账户登录',
  forgetPsword: '忘记密码',
  // goRegister1: '还没有账号？',
  goRegister2: '立即注册',
  loginDiv: '去登录',
  point1: '手机格式不正确',
  point2: '登录成功',
  footWord1: '版权所有：2019中国北京世界园艺博览会',
  footWord2: '京ICP备15016942-2',
  footWord3: '地址：北京市石景山区阜石路159号首钢体育大厦',
  footWord4: '联系电话：010-86484017',
  footWord5: '官方微博',
  footWord6: '承建运营：中国互联网新闻中心',
  footWord7: '邮政编码：100043',
  footWord8: '官方微信',
  footWord9: '官方APP',
  chooseTime: '选择入园时间',
  am: '上午',
  pm: '下午',
  atNight: '晚上',
  timeSelection: '时间段选择',
  selectDate: '票务系统温馨提示：请先选择日期和时间段',
  selectDate1: '请先选择日期和时间段',
  selectTime: '请选择时间段',
  selectTime1: '票务系统温馨提示：请选择时间段',
  notOptional: '不可选',
  optional: '可选',
  selected: '已选',
  optionalTodal: '今日',
  ticketKinds: '票 种',
  next: '下一步',
  confirm: '确 定',
  confirm1: '确定',
  pleaseInformation: '请添加购票人信息，进行实名认证',
  safelyUpgrade: '完成认证防止他人冒用身份，安全再升级',
  appointmentTime: '预约入园时间',
  completeInformation: '完善实名认证资料',
  addInformation: '添加购票人信息',
  phoneVerification: '手机验证',
  cellPhone: '手机号码',
  cellPhone1: '购票手机号',
  verificationCode: '验证码',
  sendCode: '获取验证码',
  readTerms1: '我已阅读并同意',
  readTerms2: '《购票条款》',
  enteringPark: '网络购票后，请携带有效证件刷卡入园',
  pleaseAddInformation: '请添加购票人信息',
  ticketInformation: '购票人信息',
  verified: '实名认证',
  submitCertification: '提交认证',
  name: '姓名',
  nameEmpty: '请输入姓名',
  nameEmpty1: '请输入正确姓名',
  typeCertificate: '证件类型',
  selectIdType: '请选择证件类型',
  idCard: '身份证',
  passport: '护照',
  hongKongCard: '港澳居民来往内地通行证',
  mTPs: '台湾居民来往大陆通行证',
  iDNumber: '证件号码',
  pleaseID: '请输入证件号码',
  confirmID: '确认证件号码',
  againID: '请再次输入证件号码',
  wrongIDCard: '身份证号码不正确',
  wrongOtherCard: '请输入正确的证件号码',
  twoWrongID: '两次输入证件号码不一致',
  // pleaseChinaName: '请填写中文姓名',
  sentCode: '验证码已发送',
  fillInformation: '票务系统温馨提示：请填写购票人信息',
  fillPhone: '票务系统温馨提示：请填写购票手机号码和验证码',
  fillPhone1: '票务系统温馨提示：请填写购票手机号码',
  pleaseTerms: '票务系统温馨提示：请阅读并同意《购票条款》',
  savedSuccess: '订单保存成功，去付款',
  confirmTicket: '确认购票信息',
  submit: '提 交',
  addMore: '添 加',
  noo: '序号',
  orderNum: '订单编号',
  orderInformation: '订单信息',
  bookingTimg: '购票时间',
  bookingNum1: '购票数量',
  bookingNum: '购票数量',
  orderCode: '订单确认码',
  orderStatus: '订单状态',
  toPaid: '待支付',
  paid: '已支付',
  refunding: '退款中',
  refunded: '已退款',
  orderinvalid: '订单失效',
  notIssued: '未出票',
  ticketIssued: '已出票',
  total: '总计',
  operations: '操作',
  delete: '删除',
  changeTicket: '改签',
  refund: '退票',
  refundApplication: '退票申请',
  wantRefund: '您确定要退票吗？',
  totalRefund: '共计退款',
  pleaseAlipay: '请使用微信、支付宝或云闪付，扫描以上二维码',
  noticeMinutes: '温馨提示：订单有效期为30分钟',
  noticeMinutes1: '温馨提示：订单有效期30分钟，支付完成前请不要关闭此弹窗',
  SuccessfulOrder: '订单付款成功',
  wantDelete: '确定要删除此订单吗？',
  tips: '提示',
  cancel: '取消',
  deleteSuccessfully: '订单删除成功',
  refundSuccessful: '退票成功',
  yourOrder: '您的订单情况如下',
  calendarTime: ["日", "一", "二", "三", "四", "五", "六"],
  renminbi: '元',
  registrationSuccessful: '注册成功，去登录',
  rePassword: '找回密码',
  newPassword: '请输入新的密码',
  passwordSuccessful: '密码修改成功',
  reservationFull: '预约已满，请更换日期',
  exitSuccess: '退出成功',
  closed: '关 闭',
  invoiceRise: '发票抬头',
  unitInvoice: '单位发票',
  personalInvoiceL: '个人发票',
  taxpayerNumber: '税号',
  noteInvoice: '发票备注',
  emailInvoice1: '接收发票的邮箱号',
  emailInvoice: '电子邮件',
  phoneInvoice: '接收邮件的手机号',
  selectInvoice: '请选择发票抬头',
  fillInvoice: '请填写税号',
  errorEmail: '邮箱格式不正确',
  networkTimeout: '网络超时',
  notFeature: '此功能待开放',
  fetObtain: '获取电子普通发票',
  changeLang: 'En',
  getAgain: '后再获取',
  realName: '添加实名信息',
  currentChoice: '当前选择',
  changePhone: '更改号码',
  rmbTicket: '门票',
  numVerification: '手机号验证',
  noMatchText: '预约已满，请更换日期',
  paymentAmount: '付款金额',
  ruDate: '入园日期',
  gardenComfort: '游园舒适度预测',
  comfortable: '舒适',
  moderate: '适中',
  crowded: '拥挤',
  timeChange: '请选择改签时间',
  changeDate: '改签日期',
  tipTip1: '提示：平日票只能改签时间，不能改签票种；指定日票可以改签任意时间',
  tipTip: '提示:平日票不可改签为指定日票；预约优惠票只可改签在原预约日期之后。',
  noChangeType: '票务系统温馨提示：平日票不能改签为指定日票',
  reselectChange: '票务系统温馨提示：请重新选择改签时间和时间段',
  successfullyChanged: '改签成功',
  pleaseSelecttt: '票务系统温馨提示：请选择改签时间和时间段',
  onlyOrders: '票务系统温馨提示：一个订单最多只能购买6张门票',
  onlyoneticket: '相同的证件号码只能购买一张票',
  enterdigits: '请输入6到30位,数字和字母组合的密码',
  orderexpired: '订单已失效',
  sorryError: '对不起，当前页面发生错误！',
  checkUrl: '请检查您输入的网址是否正确，点击以下按钮返回',
  tiptip: '提示：姓名或证件号码输入错误将无法入园。',
  freechange: '6周岁（2013年1月1号及之后出生）以下儿童免票',
  codeerror: '验证码输入错误',
  noticeList: [       // 首页 - 入园须知的内容
    {
        title: '带好证件，快速入园',
        content: '为了方便您快速有序入园，请您依次排队，提前准备好身份证件，经预检、门票查验和安全检查后进入园区。门票查验时，持优惠票的游客须同时出示相关享受优惠的有效证件，感谢您的配合。'
    },
    {
        title: '平安出行，安全游园',
        content: '为了保障您的人身安全，请勿携带宠物、无人机、风筝、对讲机、扩音器等可能妨碍他人参观、影响园区秩序的物品。儿童、行动不便的老人，须在成年人陪同下游园。除老年人、残疾人专用轮椅和儿童专用手推车外，其他车辆请勿入园。如遇紧急情况，请就近向工作人员寻求帮助。'
    },
    {
        title: '绿色在心，行动在手',
        content: '为了使您和他人有一个绿色、美丽的游园环境，请您文明礼貌游园，保护公共设施和环境卫生，爱护花草树木。请勿攀爬、破坏建筑和展品。'
    },
    {
        title: '和谐礼让，有序参观',
        content: '为了您和他人的安全着想，在人流密集等特殊情况下，工作人员可能会临时限制游客进入园区、展馆等，对游客进行引导疏散，请您听从工作人员的安排，感谢您的配合和理解。'
    },
    {
        title: '快乐游园，享温馨服务',
        content: '我们在园区设立的游客服务中心，将为您提供信息问询、物品寄存、轮椅和婴儿车租赁、失物招领、走失人员协助等服务。祝您游园愉快！'
    }
  ],
  noticephone1: '您可以通过服务热线电话',
  noticephone2: '010-86484017',
  noticephone3: '进行游览咨询或建议投诉，感谢您的关注。',
  loadList: [          // 购票页 - 购票须知的内容
      {
        title: '一、购票提示',
        content: [
            { con: '2019中国北京世界园艺博览会（下称“北京世园会”）个人门票的购票人和持票人应认真阅读并遵守本购票须知及相关规定；北京世园会购票实行实名制，所有购票游客须录入身份信息方可购买并预约。' }
        ]
      },
      {
        title: '二、票种及票价',
        content: [
            { con: '1．北京世园会个人门票分为指定日票和平日票：指定日票可在指定日当日或任一平日入园参观；平日票仅可在平日入园参观。' },
            { con: '2．北京世园会举办日期为2019年4月29日至2019年10月7日，共162天，其中指定日15天，包括开幕日（2019年4月29日），“五一”假期（2019年5月1日）、端午节假期（2019年6月7日、8日及9日）、中秋节假期（2019年9月13日、14日及15日）、“十一”假期（2019年10月1日至10月7日，10月7日为闭幕日）；指定日以外的举办日期为平日，共147天。' },
            { con: '3．指定日票分为指定日普通票和指定日优惠票两种；平日票分为平日普通票和平日优惠票两种。通过线上渠道购买的门票适用规则和门票价格如下表：' },
        ],
        // table: {
            trone1: '类别',
            trone2: '票 种',
            trone3: '适用规则',
            trone4: '公开零售价',
            trtwo: '个人门票',
            trthree1: '指定日票',
            trthree2: '指定日普通票',
            trthree3:[ '适用所有人士', '限一人在任一指定日或平日入园一次' ],
            trthree4: '￥160.00',
            trfour1: '指定日优惠票',
            trfour2: [
                '适用60周岁以上（含60岁）老人【即1959年12月31日及之前出生的人士 】',
                '18周岁以下的学生（2001年1月1日及之后出生的人士）',
                '适用6周岁以上且身高超过1.3米的儿童【14周岁以下，即2005年1月1日及之后出生的人士】',
                '购票及入园时需出示相关有效证件',
                '限一人在指定日或平日入园一次'
            ],
            trfour3: '￥100.00',
            trfive1: '平日票',
            trfive2: '平日普通票',
            trfive3: [ '适用所有人士', '限一人在任一平日入园一次'],
            trfive4: '￥120.00',
            trsix1: '平日优惠票',
            trsix2: [
                '适用60周岁以上（含60岁）老人【即1959年12月31日及之前出生的人士 】',
                '18周岁以下的学生（2001年1月1日及之后出生的人士）',
                '适用6周岁以上且身高超过1.3米的儿童【14周岁以下，即2005年1月1日及之后出生的人士】',
                '购票及入园时需出示相关有效证件',
                '限一人在任一平日入园一次'
            ],
            trsix3: '￥80.00',
        // },
        contentother1: '注：6周岁（2013年1月1日及之后出生）以下或身高1.3米（含）以下儿童（儿童是指14周岁以下，即2005年1月1日及之后出生的人士）免票。' ,
        contentother2: '4．门票销售阶段分为两个阶段，预售期及会期。预售期是指2019年1月19日-4月28日；会期是指2019年4月29日-10月7日。预售期享受9折优惠（优惠票除外）。' ,
      },
      {
        title: '三、预约购票及入园',
        content: [
            { con: '1．北京世园会购票实行实名制，所有购票游客须录入二代身份证（或有效护照、港澳居民来往内地通行证、台湾居民来往大陆通行证）信息。' },
            { con: '2．北京世园会线上购票时须预约入园日期。北京世园会每日可预约人次有限，线上渠道购票提前预售，如当天售票量超过上限将停止售票；现场售票点仅售当日个人门票。' },
            { con: '3．每个证件（身份证/护照/港澳居民来往内地通行证/台湾居民来往大陆通行证）每个入园日限购一张门票。' },
            { con: '4．年满60周岁的老人（1959年12月31日及之前出生的游客）及18周岁以下的学生（2001年1月1日及之后出生的游客）可通过线上渠道购买优惠票。' },
            { con: '5．其他优惠票适用人群（包括残疾人士、中国现役军人、全日制普通高等教育阶段在校学生及消防救援人员）须在现场（1、2、5号门区）指定窗口进行购票，须同时出具本人有效二代身份证及有效优惠证件。' },
            { con: '6．所有渠道当日入园门票的停止售票时间为20：00。' },
            { con: '7．购票人应在购票时核对所购门票的票种、数量和所付票款，并有权索要与购票金额一致的发票。' },
            { con: '8．持二代身份证、护照、港澳来往内地通行证或台湾居民来往大陆通行证入园的游客，如在参观当日实际入园时间在16:00（含）以后（通过系统自动识别），第二日若有入园需求，可直接刷证入园（但“参观当日为平日，而第二日为指定日”的情况除外）。' },
        ],
      },
      {
        title: '四、改签和退票规则',
        content: [
            { con: '1．在未验票的情况下，线上购票的游客可在预约入园当日20：00前在原购票渠道申请退票或改签1次，改签时指定日门票可以改签到该申请发起日后任一指定日或任一平日（差价不予退还），平日门票可以改签到该申请发起日后任一平日；如预约当日未入园，且未在预约当日20：00前进行门票改签或退票操作的，则视为已作废，无法改签或退票。' },
            { con: '2．单笔订单含多张门票（单笔订单最多可一次订购6张门票），进行改签或退票操作时，需对整个订单进行改签或退票操作，不支持对订单内的部分门票进行改签或退票。' },
            { con: '3．游客申请退票，由原购票渠道负责退款，详情请咨询原购票渠道。' },
        ],
      },
      {
        title: '五、验票说明',
        content: [
            { con: '1．免票人群和购票游客均须持有效身份证件（身份证/护照/港澳居民来往内地通行证/台湾居民来往大陆通行证）入园。' },
            { con: '2．购买优惠票的游客，入园时需出示优惠证件原件，并凭有效身份证件通过指定通道检票入园。' },
            { con: '3．线上购票时提交了身份证信息的游客，需在入园当日持身份证在1号门、2号门、5号门直接入园。' },
            { con: '4．线上购买门票时填写了护照、港澳居民来往内地通行证或台湾居民来往大陆通行证的游客，可在入园当日持购票时填写的有效证件在1号门、2号门、6号门的指定通道直接入园。' },
            { con: '5．因证件丢失、损坏或其他情况无法验票的已购票游客，须凭公安出具的临时身份证明在购票窗口兑换临时入园凭证，在凭证有效时间内入园。' },
            { con: '6．通过同一订单购票的游客，在验票时，所有人均须持购票时的有效证件检票入园，订单内任意一人验票成功后，该订单无法再申请退款或改签。' },
        ],
      },
      {
        title: '六、参观时间',
        tablesix: [
            [ '开园时间', '售票截止时间', '入园截止时间', '闭园时间' ],
            [ '08：00', '20:00', '20:00', '21:00' ],
        ],
      },
      {
        title: '七、其他',
        content: [
            { con: '1．北京世界园艺博览会事务协调局将以票务公告的方式发布票务相关信息。公众可以登录北京世园会官方网站（http://www.horti-expo2019.com/），或拨打北京世园会服务热线（0086-10 86484017）咨询票务相关信息。' },
            { con: '2．北京世界园艺博览会事务协调局有权根据运营情况调整相关规则，并通知公众及有关单位。' },
            { con: '3．除另行规定外，北京世园会园区内的展示、活动等不另行收费。' },
            { con: '4．北京世界园艺博览会事务协调局保留最终解释权。' },
        ],
      },
      
  ],
  selectInvoiceType: '请选择发票类型',
  fillInvoiceName: '请填写发票名称',
  fillInvoiceNamesss: '请填写正确的发票名称',
  invoiceEmail: '请填写电子邮件地址',
  successfulBilling: '成功开票，请到邮箱查看',
  fillInvoiceNo: '请填写正确的税号',
  nofill: '输入不合法，仅支持中英文、数字、部分特殊符号（ ，和。）',
  tiperrorsss: '温馨提示：发票一经开具，不可更改，请务必确认信息准确无误。（发票开具日期为申请开票当日）',
  tiperrorsss1: '温馨提示：',
  tiperrorsss2: '发票一经开具，不可更改，请务必确认信息准确无误。（发票开具日期为申请开票当日）',
  personaltips: '个体户、行政机关、事业单位以及社会团体等无纳税人识别号的游客，请选择“个人发票”选项申请开票。',
  tinvoicetype: '抬头类型',
  tinvoicename: '发票抬头',
  downloadinvoice: '下载电子普通发票',
  notloggen: '您还没有登录或登录已失效，正在前往登录',
  travelmodeselection: '预计出行方式',
  pleasetravelmode: '请选择出行方式',
  optionsTravel: [ 
    {
        value: '1',
        label: '世园会公交专线',
        children: [
            { value: '1', label: '地铁朱辛庄站' },
            { value: '2', label: '地铁北安河站' },
            { value: '3', label: '地铁天通苑北站' },
            { value: '4', label: '地铁金安桥站' },
            { value: '5', label: '地铁西二旗站' },
            { value: '6', label: '地铁六里桥东站' },
            // { value: '7', label: '世园会P3停车场' },
        ]
    },
    {
        value: '2',
        label: 'S2线'
    },
    {
        value: '3',
        label: '919/919快等公共交通'
    },
    {
        value: '4',
        label: '自驾车'
    },
    {
        value: '5',
        label: '出租车'
    },
    {
        value: '6',
        label: '其他方式'
    }
  ],
  discountedssss: '优惠折扣票只能改签在原预约日期之后',
  cannotbuy: '当天18点后不能购买当天门票，请选择其它日期',
  cannotchange: '当天18点后不能改签到当天门票，请选择其它日期',
  invoiced: '已开票',
  ondaypay: '优惠票订单将于当日23:59分失效，请及时支付',
  twoadvance1: '提前2天及以上在线购票的游客给予九折优惠',
  twoadvance: '优惠提醒：预订2日后门票可享受9折优惠！',
  friendlyReminder:[
      '温馨提示：',
      '预订2日后门票可享受九折优惠！',
      '预约优惠票只可改签在原预约日期之后。',
      '如需开具发票，请于购票之日起7日内在线申请。',
      '如需退票或改签，请务必于当日20:00前完成操作。',
      '每日18：30后请游客于5号门区、6号门区入园。',
  ],
  apptiptip: '票务系统温馨提示：世园会APP购买的门票，请前往世园会APP付款',


};
exports.default = _default;


// WEBPACK FOOTER //
// ./src/language/zh-CN.js